module.exports = __webpack_public_path__ + "static/media/netflix.4a9d7957.png";